import React from "react";
import RightArrow from "../../../../../images/ArrowRight.svg";
import {useNavigate} from "react-router-dom";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {ProjectData} from "../../masters/projects/queries/types";

export const projects = [
  {
    name: "project_name",
    company: "company_name",
    status: "Table Structure Not Added",
  },
  {
    name: "project_name",
    company: "company_name",
    status: "Table Structure Added",
  },
];

export enum WorkProgressPageFor {
  MASTERS = "MASTERS",
  USERS = "USERS",
  COPY_TABLE_FORMAT = "COPY_TABLE_FORMAT",
  GENERAL = "GENERAL",
}
interface WorkProgressItemProps {
  res: ProjectData;
  index: number;
  pageType: WorkProgressPageFor;
}

const WorkProgressItem = ({res, index, pageType}: WorkProgressItemProps) => {
  const navigate = useNavigate();
  const {customer_id} = useUrlParams();
  return (
    <div
      onClick={() =>
        navigate(
          `/${customer_id}/projectheaders/${res.projectDetails.id}/masters`
        )
      }
      className={`work-progress__block--grid${
        pageType === WorkProgressPageFor.GENERAL ? "" : "--copy"
      }`}
    >
      <div key={index}>{index + 1}. </div>
      <div className="work-progress__block--grid--mid">
        <b title={res.projectDetails.name} className="ellipsis-text">
          {res.projectDetails.name}
        </b>
        <span>{res.projectDetails.supplierName.desc}</span>
        <>
          <div>
            <span
              className={`work-progress__block--grid--${
                res.headerCount > 0 ? "added" : "not-added"
              }`}
            >
              {res.headerCount > 0
                ? "Table Structure Added"
                : "Table Structure Not Added"}
            </span>
          </div>
        </>
      </div>
      {pageType === WorkProgressPageFor.GENERAL && (
        <img src={RightArrow} alt="" />
      )}
    </div>
  );
};

export default WorkProgressItem;
